"use client";

import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"
import { useState, useEffect } from "react"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  // Initialize with system theme
  const [theme, setTheme] = useState<string>("system")
  const { theme: nextTheme } = useTheme()
  
  // Update theme only on client side
  useEffect(() => {
    if (nextTheme) {
      setTheme(nextTheme)
    }
  }, [nextTheme])

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          // Custom styling for each toast type
          success: "bg-[var(--color-cta-success)]/20 border-[var(--color-cta-success)]/30 text-[var(--color-cta-success)] group toast",
          error: "bg-[var(--color-cta-danger)]/20 border-[var(--color-cta-danger)]/30 text-[var(--color-cta-danger)] group toast",
          warning: "bg-[var(--color-cta-warning)]/20 border-[var(--color-cta-warning)]/30 text-[var(--color-neutral-950)] group toast",
          info: "bg-[var(--color-hover-overlay)] border-[var(--color-brand-primary)]/30 text-[var(--color-brand-primary)] group toast",
          // Base styling
          toast: "group toast group-[.toaster]:border group-[.toaster]:shadow-lg",
          description: "text-sm opacity-90",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
